// extracted by mini-css-extract-plugin
module.exports = {"root":"BottomSeperator_root__3mkvy","noViewBtn":"BottomSeperator_noViewBtn__3W_0o"};